
export const PolicyStatusType = {
    NotCreated: 0,
    Active: 1,
    Cancelled: 2,
    Updated: 3,
    Created: 4,
    CancellationInProgress: 5,
    PendingCancellation: 6,
    ActivationInProgress: 7,
    PendingActivation: 8,
} as const

export type PolicyStatusType = typeof PolicyStatusType[keyof typeof PolicyStatusType]

export const PolicyStatusTypes: [PolicyStatusType, string][] = [
    [PolicyStatusType.NotCreated, 'Nesjednáno'],
    [PolicyStatusType.Active, 'Aktivní'],
    [PolicyStatusType.Cancelled, 'Stornováno'],
    [PolicyStatusType.Updated, 'Aktualizováno'],
    [PolicyStatusType.Created, 'Vytvořeno'],
    [PolicyStatusType.CancellationInProgress, 'Probíhá storno'],
    [PolicyStatusType.PendingCancellation, 'Čeká na storno'],
    [PolicyStatusType.ActivationInProgress, 'Probíhá aktivace'],
    [PolicyStatusType.PendingActivation, 'Čeká na aktivaci'],
]

export const getPolicyStatusName = (type: PolicyStatusType | undefined) =>
    type !== undefined ? PolicyStatusTypes.find(([key]) => key === type)?.[1] : undefined
